import { render, staticRenderFns } from "./cr_scoped_show.vue?vue&type=template&id=260895ff&"
import script from "./cr_scoped_show.vue?vue&type=script&lang=js&"
export * from "./cr_scoped_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260895ff')) {
      api.createRecord('260895ff', component.options)
    } else {
      api.reload('260895ff', component.options)
    }
    module.hot.accept("./cr_scoped_show.vue?vue&type=template&id=260895ff&", function () {
      api.rerender('260895ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_scoped_show.vue"
export default component.exports